import { ChangeDetectionStrategy, Component, computed, inject, output } from "@angular/core";
import { HeaderComponent, MenuElement, Representation, User } from "@husbanken/designsystem-angular-header-v2";
import { AuthService, Feature, IsFeatureEnabledPipe } from "@husbanken/frontend-starter";

@Component({
  selector: "bko-header",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeaderComponent, IsFeatureEnabledPipe],
  template: `
    <hb-header-v2
      serviceName="felles-template-application"
      languageLabel="Språk"
      [applicationLogoLink]="'/'"
      [showHeaderLogout]="false"
      [isCompactHeader]="true"
      [showHusbankenLogo]="true"
      [languageListInfo]="(Feature.SPRAKVELGER | isFeatureEnabled) ? languageList : undefined"
      (changeLanguage)="changeLanguage.emit($event)"
      [user]="user()"
      (logout)="logout.emit()"
    >
    </hb-header-v2>
  `,
})
export class AppHeaderComponent {
  public authService = inject(AuthService);

  public changeLanguage = output<string>();
  public changeRepresentation = output<Representation>();
  public logout = output<void>();

  public Feature = Feature;

  public user = computed<User>(() => {
    const user = this.authService.user();
    return { personNavn: user?.name, personNummer: user?.pid };
  });

  protected languageList = [
    {
      code: "nb",
      name: "Bokmål",
    },
    {
      code: "nn",
      name: "Nynorsk",
    },
    {
      code: "en",
      name: "English",
    },
  ];
}
